import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface E55FileDetails {
  fileId: number;
  fileName: string;
  operatorByFileUploader: string;
  operatorByInboundPpo: string;
  operatorByOutboundPpo: string;
  accountingYear: number;
  accountingQuarter: number;
  fileVersion: number;
  creationDate: string;
  inboundRemovalDate: string | null;
  outboundRemovalDate: string | null;
  fileStatus: string;
  processDate: string | null;
  inboundAcceptanceDate: string | null;
  outboundAcceptanceDate: string | null;
  notifiedDate: string | null;
  downloadDate: string | null;
  validStatus: string | null;
  samplesCount: number | null;
  pendingOn: string;
  loggedUserOperator: string;
  samples: any | null;
}

interface UseE55FileDetailsParams {
  fileId: number | string | undefined;
  enabled?: boolean;
}

/**
 * Hook to fetch E55 file details by ID
 * 
 * @param params Object containing the file ID and enabled flag
 * @returns Query result with the E55 file details
 */
export const useE55FileDetails = ({ fileId, enabled = true }: UseE55FileDetailsParams) => {
  const numericFileId = fileId ? parseInt(String(fileId), 10) : undefined;
  const isValidId = numericFileId !== undefined && !isNaN(numericFileId) && numericFileId > 0;

  return useQuery<E55FileDetails>({
    queryKey: ['e55FileDetails', numericFileId],
    queryFn: async () => {
      if (!isValidId) {
        throw new Error('Invalid file ID');
      }

      const response = await axios.get(`/data-set/e55/${numericFileId}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: enabled && isValidId
  });
}; 